/**
 * Mirrors packages/shared/src/types/referral.ts REFERRAL_SOURCE_OPTIONS
 * (tenant-client dev container does not always resolve @shared until shared is mounted).
 */

export const REFERRAL_SOURCE_OPTIONS = [
  { value: 'current_tenant', label: 'Referred by current Amber Peak tenant' },
  { value: 'upcoming_tenant', label: 'Referred by upcoming Amber Peak tenant' },
  { value: 'former_tenant', label: 'Referred by former Amber Peak tenant' },
  { value: 'social_media', label: 'Social media' },
  { value: 'online_review', label: 'Online review/website' },
  { value: 'google', label: 'Google' },
  { value: 'queens_housing_fair', label: "Queen's Housing Fair" },
] as const;

/** Channels where we do not ask for a specific person's name. */
const NON_PERSON_REFERRAL_SOURCES = new Set<string>([
  'social_media',
  'online_review',
  'google',
  'queens_housing_fair',
]);

export function isPersonBasedReferralSource(value: string | null | undefined): boolean {
  const trimmed = value?.trim();
  if (!trimmed) return false;
  if (NON_PERSON_REFERRAL_SOURCES.has(trimmed)) return false;
  /** Legacy person-based values (colleague, classmate, etc.) still require a name. */
  return true;
}
